var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgShopCreationImg(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 127,
    height: 127,
    viewBox: "0 0 127 127",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_357_6292)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 127,
    height: 127,
    rx: 63.5,
    fill: "#EFEFEF"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_357_6292)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M63 140C100.555 140 131 109.555 131 72C131 34.4446 100.555 4 63 4C25.4446 4 -5 34.4446 -5 72C-5 109.555 25.4446 140 63 140Z",
    fill: "#EFEFEF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M110.754 120.414C84.1262 146.822 40.9935 146.382 14.5858 119.754C16.1262 115.353 19.4272 111.612 23.3884 109.191C26.2492 107.21 29.11 105.45 32.411 104.129C27.5696 87.4045 40.7735 79.2621 45.835 77.0615C45.835 84.7638 53.0971 79.7023 61.8997 79.7023C69.1618 79.7023 83.6861 87.1845 83.6861 77.5016C91.8285 79.9223 100.631 95.3269 94.4693 104.79C96.89 106.11 99.3107 107.43 101.511 109.191C105.913 111.612 108.994 115.793 110.754 120.414Z",
    fill: "#677079"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M47.8155 89.1651L80.8252 89.3851V96.8673V97.0874C80.8252 97.5275 80.8252 97.7476 80.6052 98.1877V98.8479V99.068C78.4045 110.291 69.1618 114.472 63.4401 117.553C57.2783 114.252 48.9159 108.311 48.2557 97.7476V97.5275V97.0874C48.2557 96.8673 48.2557 96.8673 48.2557 96.6473V96.8673L47.8155 89.1651Z",
    fill: "#CECECE"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.11,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M80.8252 88.945V97.7476C80.8252 98.6278 80.8252 99.288 80.6052 100.168C80.3851 101.269 80.1651 102.149 79.7249 103.029C68.2816 111.612 50.2362 104.57 47.1553 89.8252L80.8252 88.945Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.8317 59.4563C24.0485 62.3172 33.2913 75.521 40.1133 75.521C37.2524 70.6796 35.4919 65.178 34.8317 59.4563ZM91.3883 59.4563C102.172 62.3172 92.9288 75.521 86.1068 75.521C88.9676 70.6796 90.7282 65.178 91.3883 59.4563Z",
    fill: "#CECECE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M62.5599 29.0874C107.673 29.0874 90.068 100.388 62.5599 100.388C36.5922 100.388 17.4466 29.0874 62.5599 29.0874Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M41.2136 52.6343C42.534 54.1748 42.534 56.5955 40.9935 58.1359C40.7735 58.356 40.5534 58.576 40.3333 58.576C37.0324 61.2168 37.0324 70.4595 37.0324 70.4595C35.712 69.1392 35.932 62.7573 33.0712 58.7961C30.2104 54.8349 28.6699 28.4272 43.6343 18.9644C41.8738 21.165 40.9935 24.0259 41.6537 26.8867C41.6537 26.8867 51.9968 11.9223 69.1618 12.3625C66.301 13.9029 64.3204 16.5437 63.6602 19.6246C63.6602 19.6246 78.6246 13.4628 91.1683 20.7249C87.8673 21.6052 84.7864 23.1456 82.1456 24.9061C88.3074 25.1262 94.0291 26.2265 98.6505 30.1877C94.6893 31.5081 92.4887 35.6893 93.8091 39.6505V39.8705C95.7896 47.5728 95.7896 54.8349 94.0291 58.576C92.2686 62.5372 91.3883 59.8964 90.288 68.0388C90.068 69.1392 89.6278 70.2395 88.5275 70.6796C88.5275 71.3398 89.4078 62.3171 86.9871 60.1165C84.7864 57.6958 86.1068 54.8349 86.9871 53.0744C93.3689 41.1909 74.2233 35.6893 63.8803 35.6893C55.0777 35.6893 33.2913 39.8705 41.2136 52.6343Z",
    fill: "#565656"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.5728 112.272C38.5728 112.272 61.4596 141.981 88.3074 111.832C85.0065 120.854 71.1424 127.896 63 127.896C47.8155 127.676 39.233 115.353 38.5728 112.272Z",
    fill: "#434955"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M74.8835 138.9C74.0032 139.12 73.123 139.12 72.2427 139.34V119.754C72.2427 119.094 72.9029 118.654 73.5631 118.654C74.2233 118.654 74.8835 119.094 74.8835 119.754V138.9ZM53.3172 139.34C52.4369 139.12 51.5566 139.12 50.6764 138.9V119.754C50.6764 119.094 51.3366 118.654 51.9968 118.654C52.657 118.654 53.3172 119.094 53.3172 119.754V139.34Z",
    fill: "#E6E6E6"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_357_6292"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 127,
    height: 127,
    rx: 63.5,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_357_6292"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 136,
    height: 136,
    fill: "white",
    transform: "translate(-5 4)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShopCreationImg);
export default __webpack_public_path__ + "static/media/shop-creation-img.fc7c9e8c428fd4e9956a5c2aebe78923.svg";
export { ForwardRef as ReactComponent };